import React from "react";
import { Navigate, Route, Routes } from "react-router";

import { router } from "./app/services/router";
import { SignInPage } from "./pages/SignInPage";

const ForgotPasswordPage = React.lazy(() =>
  import(/* webpackPrefetch: true */ "./pages/ForgotPasswordPage").then(
    (module) => ({
      default: module.ForgotPasswordPage,
    }),
  ),
);
const ForgotPasswordSubmitPage = React.lazy(() =>
  import(/* webpackPrefetch: true */ "./pages/ForgotPasswordSubmitPage").then(
    (module) => ({
      default: module.ForgotPasswordSubmitPage,
    }),
  ),
);

export const AuthenticationAppRoutes = () => (
  <Routes>
    <Route element={<SignInPage />} index />
    <Route
      element={
        <React.Suspense fallback={null}>
          <ForgotPasswordPage />
        </React.Suspense>
      }
      path={router.getPath("forgotPassword")}
    />
    <Route
      element={
        <React.Suspense fallback={null}>
          <ForgotPasswordSubmitPage />
        </React.Suspense>
      }
      path={router.getPath("forgotPasswordSubmit")}
    />
    <Route element={<Navigate replace to={router.getTo("home")} />} path="*" />
  </Routes>
);
